import { CLEAR_PARCELS } from "data/constants"

export function clearParcels() {
  return dispatch => dispatch({
    type: CLEAR_PARCELS,
  })
}



// WEBPACK FOOTER //
// ./src/data/actions/parcels.js